export const dataHooks = {
  root: 'pagination.root',
  navigationButtons: {
    first: 'pagination.navigation-button.first',
    previous: 'pagination.navigation-button.previous',
    next: 'pagination.navigation-button.next',
    last: 'pagination.navigation-button.last',
  },
  currentPage: 'pagination.current-page',
  currentPageAriaLabel: 'pagination.current-page.aria-label',
};
